import React from 'react';
import {createViewConfig, view} from '@sail/engine';
import type {View} from '../../view';
import {tokens} from '../../tokens';
import {css} from '../../css';
import {useUiConfig} from '../../providers/UiConfigProvider';

export type DialogContentProps = View.IntrinsicElement<
  'article',
  {
    /** Body content for the Dialog. Content overflow will be handled automatically. */
    children: React.ReactNode;
  }
>;

export const DialogContentConfig = createViewConfig({
  name: 'DialogContent',
  props: {} as DialogContentProps,
  flattens: true,
});

/**
 * The main content of a Dialog.
 */
export const DialogContent = DialogContentConfig.createView((props) => {
  const isSmallScreen = useUiConfig()?.isSmallScreen;

  return (
    <view.article
      uses={[
        css({
          overscrollBehaviorY: 'contain',
          flexShrink: 1,
          position: 'relative',
          overflowY: 'auto',
        }),

        isSmallScreen
          ? css({
              padding: tokens.space[250],
              font: 'body.medium',
            })
          : css({
              padding: 'medium',
              font: 'body.small',
            }),
      ]}
      {...props}
    />
  );
});
